export enum ObjectFoundAffair {
  OBJECT_FOUND = 'OBJECT_FOUND',
  OTHERS = 'OTHERS'
}
